import { LevelModel } from 'shared/domain/level/types/model';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { levelEntityToModel } from 'serviceWorker/repository/level/mappings';
import { getUsersSynchronized } from 'serviceWorker/services/users/getUsers';
import { debugLog } from 'shared/logger/debugLog';
import * as dbLevels from '../db/levels/levels';
import * as dbLevelsService from '../db/levels/levelsService';
import { levelContract } from 'shared/domain/level/levelContract';
import { makeErrorPublisher, makeEventPublisher, makeLoadedEventPublisher, readCollectionPayload } from 'serviceWorker/broadcasts/publishers';

const broadcastLevelError = makeErrorPublisher(
  levelContract
);

export const broadcastAllLevels = makeLoadedEventPublisher(
  levelContract,
  DomainMessagesTypes.allLevels,
  () => readCollectionPayload(dbLevelsService, async () => {
    const [levels, users] = await Promise.all([
      dbLevels.get(),
      getUsersSynchronized(),
    ]);
    return levels.map((level) => levelEntityToModel(level, users));
  })
);

export const broadcastUploadedLevel = makeEventPublisher(levelContract, DomainMessagesTypes.uploadedEntity);

export const broadcastDeletedLevel = makeEventPublisher(levelContract, DomainMessagesTypes.deletedEntity);

export const broadcastUpdatedLevels = makeEventPublisher(levelContract, DomainMessagesTypes.updatedEntity);

/** `uniqueId` of the failed change lets its command reject with this error. */
export const broadcastUploadedLevelError = (
  error: unknown,
  messageId?: string | null,
  uniqueId?: string
): void => {
  debugLog('broadcastUploadedLevelError', error, messageId, uniqueId);
  broadcastLevelError(DomainMessagesTypes.failUploadedEntity, error, {
    messageId: messageId || undefined,
    uniqueId,
  });
};
